export default __webpack_public_path__ + "locales/pl/ChangePasswordDialog.json?hash=60eae6211e7cf7f4ee9ca0ae972a5ff8";